document.addEventListener('DOMContentLoaded', function(){
    const importButton = document.getElementById('import-btn');
    const importForm = document.getElementById('import-scv-file');

    if (importButton && importForm){
        importButton.addEventListener('click', function(){
            importForm.classList.toggle('show');
        });
    }
});